import script from "./TopUpPackage.vue?vue&type=script&setup=true&lang=js"
export * from "./TopUpPackage.vue?vue&type=script&setup=true&lang=js"

import "./TopUpPackage.vue?vue&type=style&index=0&id=79aacc35&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79aacc35"]])

export default __exports__